import { ModalContext } from "@/pages/_app";
import { useContext, useEffect, useRef } from "react";

const useOnClickOutside = (refs, callback) => {
  const callbackRef = useRef();
  const Context = useContext(ModalContext);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !Context?.state.auth && refs.every((ref) => ref.current && !ref.current.contains(event.target))
      ) {
        callbackRef.current(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [Context?.state.auth, refs]);
};

export default useOnClickOutside;
